import { StartEventDto } from "../api/DroneEvents/models";
import { Drone } from "../api/DroneEvents/types";

export interface MurphyDroneEventDto {
  Id: number;
  Name: string;
  CreatedUTC: string;
  LastUpdatedUTC: string;
  Open: boolean;
  CreatedByUserEmail: string;
  Longitude?: string;
  Latitude?: string;
}

export interface MurphyPossibleDroneEventDto {
  Id: number;
  Name: string;
  Description: string;
  Type: 1 | 2 | 3 | 4;
  GeoLocationEnabled: boolean;
  ConfirmBeforeStart: boolean;
}

export type MurphyOpenedDroneEventDto = Drone & {
  Tabs: string;
};

export interface HistoryDto {
	Key: number;
	BlockTitle: string;
	Title: string;
	InputText?: string;
	Text: string;
	Checked: boolean;
	BlockId: number;
	BlockType: number;
	Time: Date;
	CreatedBy: string;
	ModifiedBy?: string;
}

export interface StartedEventFlowHistoryDto {
	Key: number;
	Completed: boolean;
	Time: Date;
	CreatedBy: string;
	ModifiedBy?: string;
}

export interface StartDroneEventResponseDto {
  openFlowIdId: number;
  timeLine: TimeLineDto[];
}

export interface TimeLineDto {
  Username: string;
  key: number;
  label: string;
  status: string;
  time: string;
}

export interface IDroneEventsApi {
  getStartedEvents: (customerId: string, includeClosed?: boolean) => Promise<MurphyDroneEventDto[]>;
  getEvents: (customerId: string) => Promise<MurphyPossibleDroneEventDto[]>;
  getEvent: (eventId: number) => Promise<MurphyOpenedDroneEventDto>;
  startEvent: (startEventDto: StartEventDto) => Promise<StartDroneEventResponseDto>;
  saveFieldInEvent: (props: {
    droneId: number;
    fieldId: number;
    updateValue: boolean | string;
  }) => Promise<void>;
  completeEvent: (props: { droneId: number }) => Promise<TimeLineDto>;
  reopenEvent: (props: { droneId: number }) => Promise<void>;
}

const DroneEventsApiType = {
  IDroneEventsApi: Symbol("IDroneEventsApi"),
};

export default DroneEventsApiType;
